import React from 'react';
import { graphql } from 'gatsby';
import NewsCarousel from './NewsCarousel';
const ModularBlogNewsCarousel = ({ data }) => {
  const { heading, backgroundColor } = data;
  return (
    <div className="modular-blogs-news-carousel-container">
      <NewsCarousel heading={heading} backgroundColor={backgroundColor} />
    </div>
  );
};

export default ModularBlogNewsCarousel;
export const fragment = graphql`
  fragment ModularBlogAndNewsCarousel on DatoCmsBlogAndNewsCarousel {
    internal {
      type
    }
    id
    backgroundColor
    heading {
      value
    }
  }
`;
